export default "__VITE_ASSET__6hC3lorl__"